import { NgModule } from '@angular/core';

import { PagesComponent } from './pages.component';
import { DashboardModule } from './dashboard/dashboard.module';
import { ActividadDetalleModule } from './actividad-detalle/actividad-detalle.module';
import { PagesRoutingModule } from './pages-routing.module';
import { ThemeModule } from '../@theme/theme.module';
import { CheckDataModule } from './check-data/check-data.module';
import { InicioComponent } from './inicio/inicio.component';
import { PublicModule } from '../public/public.module';
import { PerfilUsuarioComponent } from './perfil-usuario/perfil-usuario.component'
import { AddDireccionesExtraComponent } from '../custom_components/add-direcciones-extra/add-direcciones-extra.component';
import { AddRedesSocialesExtraComponent } from '../custom_components/add-redes-sociales-extra/add-redes-sociales-extra.component';
import { HacerseSocioComponent } from './hacerse-socio/hacerse-socio.component';
import { AdminDatosEntidadComponent } from './admin-datos-entidad/admin-datos-entidad.component';
import { 
  NbSelectModule,
  NbRadioModule,
  NbStepperModule,
  NbSpinnerModule
} from '@nebular/theme';
import { AngularFileUploaderModule } from "angular-file-uploader";
import { Ng2SmartTableModule } from 'ng2-smart-table';
import {AccionTablaArchivosEntidadComponent } from '../custom_components/AccionTablaArchivosEntidad/AccionTablaArchivosEntidad.component'
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MyInterceptor } from '../@theme/interceptors/my.interceptor';
import { ProcesoCompraComponent } from './proceso-compra/proceso-compra.component';
import { NgxBraintreeModule } from 'ngx-braintree';
import { HttpClientModule } from '@angular/common/http';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { CambiarPasswordComponent } from './cambiarPassword/cambiar-password.component';
import { RouterModule } from '@angular/router';
import { InformesComponent } from './informes/informes.component';
import { CustomInputDateRenderComponent, CustomInputDate } from '../custom_components/InputDate/customInputDate.component';
import { AccionDescargarEntradaComponent } from '../custom_components/AccionDescargarEntrada/AccionDescargarEntrada.component';
import { PestaniaSocialComponent } from './pestaniaSocial/pestania-social.component';
import { MatChipsModule, MatIconModule, MatFormFieldModule, MatAutocomplete, MatAutocompleteModule, MatSlideToggleModule } from '@angular/material';
import { AddRedesSocialesSocialComponent } from '../custom_components/add-redes-sociales-social/add-redes-sociales-social.component';
import { AdminForosComponent } from './admin-foros/admin-foros.component';
import { AdminSubForosComponent } from './admin-subforos/admin-subforos.component';
import { AdminTemasComponent } from './admin-temas/admin-temas.component';
import { UserForosComponent } from './user-foros/user-foros.component';
import { UserSubForosComponent } from './user-subforos/user-subforos.component';
import { UserTemasComponent } from './user-temas/user-temas.component';
import { AceptarTemasComponent } from './aceptar-temas/aceptar-temas.component';
import { ForosMensajesComponent } from './foros-mensajes/foros-mensajes.component';
import { AvatarModule } from 'ngx-avatar';
import { MuroPersonalComponent } from './muroPersonal/muro-personal.component';
import { NgxGalleryModule } from 'ngx-gallery';
import { TextareaAutosizeModule } from 'ngx-textarea-autosize';
import { MuroUsuariosComponent } from './muroUsuarios/muro-usuarios.component';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import { MuroFormativoComponent } from './muroFormativo/muro-formativo.component';
import { MuroSocialFormativoComponent } from './muroSocialFormativo/muroSocial-formativo.component';
import { MuroGrupoTrabajoAComponent } from './muroGrupoTrabajoAdmin/muro-trabajoA.component';
import { MuroGrupoTrabajoUsuariosComponent } from './muroGrupoTrabajoUsuarios/muro-trabajoUser.component';
import { MuroGrupoTrabajoComponent } from './muroGrupoTrabajo/muro-grupoTrabajo.component';
import { BuscadorComponent } from './Buscador/buscador.component';
import { AdminBajaSocialComponent } from './admin-bajaSocial/admin-bajaSocial.component';

const PAGES_COMPONENTS = [
  PagesComponent
];

@NgModule({
  imports: [
    PagesRoutingModule,
    ThemeModule,
    ActividadDetalleModule,
    DashboardModule,
    CheckDataModule,
    PublicModule,
    NbSelectModule,
    AngularFileUploaderModule,
    Ng2SmartTableModule,
    AvatarModule,
    NbRadioModule,
    NbStepperModule,
    NbSpinnerModule,
    NgxBraintreeModule,
    HttpClientModule,
    AngularEditorModule,
    RouterModule,
    MatChipsModule,
    MatIconModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatSlideToggleModule,
    NgxGalleryModule,
    TextareaAutosizeModule,
    InfiniteScrollModule,
  ],
  declarations: [
    ...PAGES_COMPONENTS,
    InicioComponent,
    PerfilUsuarioComponent,
    AddDireccionesExtraComponent,
    AddRedesSocialesExtraComponent,
    AddRedesSocialesSocialComponent,
    HacerseSocioComponent,
    AdminDatosEntidadComponent,
    AdminForosComponent,
    AdminSubForosComponent,
    AdminTemasComponent,
    UserForosComponent,
    UserSubForosComponent,
    UserTemasComponent,
    AceptarTemasComponent,
    ForosMensajesComponent,
    MuroPersonalComponent,
    MuroUsuariosComponent,
    MuroFormativoComponent,
    MuroSocialFormativoComponent,
    MuroGrupoTrabajoAComponent,
    MuroGrupoTrabajoUsuariosComponent,
    MuroGrupoTrabajoComponent,
    BuscadorComponent,
    AdminBajaSocialComponent,
    AccionTablaArchivosEntidadComponent,
    AccionDescargarEntradaComponent,
    ProcesoCompraComponent,
    CambiarPasswordComponent,
    PestaniaSocialComponent,
    InformesComponent,
    CustomInputDateRenderComponent,
    CustomInputDate
  ],
  entryComponents: [
    AccionTablaArchivosEntidadComponent,
    AccionDescargarEntradaComponent,
    CustomInputDateRenderComponent,
    CustomInputDate
  ], providers: [
    { provide: HTTP_INTERCEPTORS, useClass: MyInterceptor, multi: true },
  ],
})
export class PagesModule  {
}
